"use client"

import React from 'react';
import styles from "./Saints.module.scss";
import {useAppStore} from "@/store/AppStore";
import {Liturgy} from "@/types/Liturgies";
import useSaintsData from "@/utils/hooks/useSaintsData";
import LoginAlert from "@/components/LoginAlert/LoginAlert";
import AuthenticatedImage from "@/components/SubmitPost/AuthenticatedImage";
import {Chip, Divider, Stack} from "@mui/material";
import {Link} from "@/i18n/routing";
import HikingIcon from "@mui/icons-material/Hiking";

export default function Saints(params: { currentId?: string }) {
  const {currentId} = params
  const user = useAppStore((state) => state.user);
  const data = useSaintsData(user?.access_token)
  const items = data?.items

  // `opened` deriva da `currentId` (formato `saint-<id>`).
  const opened = currentId?.includes("saint")
    ? Number(currentId.split("saint-")[1])
    : undefined


  if (!currentId) return null
  if (!currentId.includes("saint")) return null
  if (!user) return <LoginAlert/>


  const actives: Liturgy | undefined = opened ? items?.find((itm) => {
    return itm.id === opened
  }) : undefined


  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          {actives && actives && <div>
            <h2 className={styles.prayerTitle}>{actives?.name}</h2>
            {actives?.credits && <h5 className={styles.prayerCredits}>{actives?.credits}</h5>}
            {actives?.image && actives?.image?.url &&
                <div className={styles.imageWrapper}><AuthenticatedImage authToken={user?.access_token || ""} fill
                                                                         objectFit={"contain"}
                                                                         alt={actives?.image?.alt_text || ""}
                                                                         imageUrl={actives?.image?.url || ""}/>
                </div>}
            {actives?.description && <div dangerouslySetInnerHTML={{__html: String(actives?.description)}}/>}
            {actives?.embed_content &&
                <div className={styles.embed} dangerouslySetInnerHTML={{__html: String(actives?.embed_content)}}/>}
            <div dangerouslySetInnerHTML={{__html: String(actives?.content)}}/>
            <Divider sx={{my: 5}}/>
            <Stack direction={"row"} sx={{gap: 2, flexWrap: "wrap"}}>{actives.segments && actives.segments.map((item, key) => {
              return <Link key={key} href={"/tappa/" + item.id}>
                <Chip icon={<HikingIcon/>} size={"small"}
                      label={item.name}
                      color="primary"
                      variant="outlined"/>
              </Link>
            })}</Stack>
          </div>
          }
        </div>
      </div>
    </div>
  )
}
